(() => {
  const REVIEW_LINK_TIMEOUT_MS = 10000;
  const reviewLinkSelector = '[data-treen-okendo-review-link]';
  const widgetSelector = '[data-oke-widget]';
  const nativeReviewLinkSelector =
    '[data-oke-widget] a[href^="https://okendo.reviews/"][href*="productId=shopify-"]';
  const activeObservers = new Map();

  const stopObserver = (observer) => {
    const timeoutId = activeObservers.get(observer);
    if (timeoutId) window.clearTimeout(timeoutId);
    observer.disconnect();
    activeObservers.delete(observer);
  };

  const stopAllObservers = () => {
    activeObservers.forEach((_timeoutId, observer) => stopObserver(observer));
  };

  const getNativeReviewUrl = () => {
    const nativeReviewLink = document.querySelector(nativeReviewLinkSelector);

    if (!nativeReviewLink) return null;

    try {
      const reviewUrl = new URL(nativeReviewLink.href);
      const productId = reviewUrl.searchParams.get('productId');

      if (reviewUrl.hostname !== 'okendo.reviews' || !productId?.startsWith('shopify-')) return null;

      return reviewUrl.href;
    } catch (_error) {
      return null;
    }
  };

  const promoteReviewLinks = () => {
    const reviewUrl = getNativeReviewUrl();

    if (!reviewUrl) return false;

    document.querySelectorAll(reviewLinkSelector).forEach((reviewLink) => {
      reviewLink.href = reviewUrl;
      reviewLink.target = '_blank';
      reviewLink.rel = 'noopener';

      const label = reviewLink.textContent.trim();
      if (label) reviewLink.setAttribute('aria-label', `${label} (opens in a new window)`);
    });

    return true;
  };

  const initializeDirectReviewLinks = () => {
    if (promoteReviewLinks()) return;

    const widget = document.querySelector(widgetSelector);
    if (!widget) return;

    const observer = new MutationObserver(() => {
      if (promoteReviewLinks()) stopObserver(observer);
    });

    observer.observe(widget, { childList: true, subtree: true });
    const timeoutId = window.setTimeout(() => stopObserver(observer), REVIEW_LINK_TIMEOUT_MS);
    activeObservers.set(observer, timeoutId);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDirectReviewLinks, { once: true });
  } else {
    initializeDirectReviewLinks();
  }

  document.addEventListener('oke-rendered', promoteReviewLinks);
  document.addEventListener('shopify:section:load', initializeDirectReviewLinks);
  document.addEventListener('shopify:section:unload', stopAllObservers);
})();
